"use strict";

define('app/print/letter/print.letter.view',['app/print/abstract/print.abstract.view'], function (AbstractContentView) {
  var PrintLetterView = AbstractContentView.extend({
    templates: {
      'print.letter.init': 'renderInitFragment'
    },
    render: function render(content) {
      var delegate = this.getDelegate(),
        data = {
          content: content
        };
      this.$el.html(this.renderInitFragment(data));
    }
  });
  return PrintLetterView;
});

